let signerTextPosition = [
  'TOP',
  'BOTTOM',
  'RIGHT',
  'LEFT'
]

export default signerTextPosition
